import type { QueryKey } from '@tanstack/react-query';
import { cloneDeep, isObject } from 'lodash';

export function moveArray<T>(originalArray: T[], fromIndex: number, toIndex: number) {
  const result = cloneDeep(originalArray);
  const startIndex = fromIndex < 0 ? result.length + fromIndex : fromIndex;

  if (startIndex >= 0 && startIndex < result.length) {
    const endIndex = toIndex < 0 ? result.length + toIndex : toIndex;

    const [item] = result.splice(fromIndex, 1);
    result.splice(endIndex, 0, item);
  }
  return result;
}

export function extractPathAndParams(
  arr: QueryKey,
): [Array<string | number | boolean>, Record<string, unknown>] {
  const primitives: Array<string | number | boolean> = [];
  let mergedParams: Record<string, unknown> = {};

  arr.forEach((item) => {
    if (isObject(item)) {
      mergedParams = { ...mergedParams, ...item };
    } else {
      primitives.push(item as string | number | boolean);
    }
  });

  return [primitives, mergedParams];
}
